import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/modules/shared.module';

import { PasswordStrengthWidgetComponent } from './password-strength-widget.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    PasswordStrengthWidgetComponent,
  ],
  exports: [
    PasswordStrengthWidgetComponent,
  ],
})
export class PasswordStrengthWidgetModule {}
